export default "__VITE_ASSET__BfG$Euza__"